import React, { useCallback, useEffect, useMemo } from 'react';
import { useSharedValue } from 'react-native-reanimated';
import Text from 'design-system/Text';
import InteractivePieChart from 'design-system/InteractivePieChart';
import { formatPlural } from 'utils/formatting';
const emptyText = {
    title: '',
    subTitle: '',
};
const InsightsPieChart = ({ data, total, count, category, sliceIndexMap, defaultSliceKey, selectedPieSlice, setSelectedPieSlice, }) => {
    const selectedPieSliceKey = useSharedValue('none');
    useEffect(() => {
        setSelectedPieSlice(defaultSliceKey);
        selectedPieSliceKey.value = defaultSliceKey;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultSliceKey]);
    const onSelectPieSlice = useCallback((pieSlice) => {
        setSelectedPieSlice(pieSlice.key);
        selectedPieSliceKey.value = pieSlice.key;
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setSelectedPieSlice]);
    const text = useMemo(() => {
        if (!selectedPieSlice) {
            return emptyText;
        }
        const index = sliceIndexMap[selectedPieSlice];
        if (index === undefined)
            return emptyText;
        const info = data[index];
        if (!('name' in info.category))
            return emptyText;
        switch (category) {
            case 'HOLDINGS': {
                return {
                    subTitle: info.category.name,
                    title: !total ? '0%' : `${((info.value / total) * 100).toFixed(2)}%`,
                };
            }
            case 'SECTOR': {
                return {
                    title: `${count} ${formatPlural('Sector', 'Sectors', count)}`,
                    subTitle: info.category.name,
                };
            }
            default:
                return emptyText;
        }
    }, [category, count, data, selectedPieSlice, sliceIndexMap, total]);
    return (<InteractivePieChart pieSlices={data} onSelectPieSlice={onSelectPieSlice} selectedPieSliceKey={selectedPieSliceKey}>
      <Text Numbers-24 numberOfLines={1}>
        {text.title}
      </Text>
      <Text TextThin-14 Gray numberOfLines={1}>
        {text.subTitle}
      </Text>
    </InteractivePieChart>);
};
export default InsightsPieChart;
